import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2, Plus, Newspaper } from "lucide-react";
import { api } from "../lib/api";

const EMPTY = { title: "", excerpt: "", content: "", published: true };

export const BlogAdmin = () => {
  const [posts, setPosts] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/admin/blog").then((r) => setPosts(r.data)).catch(console.error);
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing.id) await api.put(`/admin/blog/${editing.id}`, editing);
      else await api.post("/admin/blog", editing);
      toast.success("Article enregistré");
      setEditing(null); load();
    } catch (err) { toast.error(err.response?.data?.detail || "Erreur"); }
  };
  const del = async (id) => {
    if (!window.confirm("Supprimer cet article ?")) return;
    await api.delete(`/admin/blog/${id}`); toast.success("Supprimé"); load();
  };

  return (
    <div data-testid="blog-admin">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-anton text-xl uppercase text-white flex items-center gap-2"><Newspaper className="h-5 w-5 text-neon-green" /> Blog SEO</h2>
        <button data-testid="blog-new" onClick={() => setEditing({ ...EMPTY })} className="flex items-center gap-1 bg-neon-green text-black font-bold uppercase text-xs px-4 py-2"><Plus className="h-4 w-4" /> Nouvel article</button>
      </div>

      {editing && (
        <form onSubmit={save} className="bg-ink-surface border border-neon-green/40 p-5 mb-6 space-y-3">
          <input data-testid="blog-title" value={editing.title} onChange={(e) => setEditing({ ...editing, title: e.target.value })} placeholder="Titre (le slug/URL est généré automatiquement)" className="w-full bg-ink border border-zinc-700 text-white px-3 py-2" />
          <input data-testid="blog-excerpt" value={editing.excerpt} onChange={(e) => setEditing({ ...editing, excerpt: e.target.value })} placeholder="Résumé (affiché dans la liste + meta description SEO)" className="w-full bg-ink border border-zinc-700 text-white px-3 py-2" />
          <textarea data-testid="blog-content" value={editing.content} onChange={(e) => setEditing({ ...editing, content: e.target.value })} rows={12} placeholder={"Contenu de l'article.\nAstuce : commence une ligne par « ## » pour un sous-titre, « - » pour une puce."} className="w-full bg-ink border border-zinc-700 text-white px-3 py-2 text-sm" />
          <label className="flex items-center gap-2 text-zinc-300 text-sm"><input type="checkbox" checked={editing.published} onChange={(e) => setEditing({ ...editing, published: e.target.checked })} className="accent-[#9dff00]" /> Publié (visible sur le site)</label>
          <div className="flex gap-2">
            <button type="submit" data-testid="blog-save" className="bg-neon-magenta text-white font-anton uppercase px-6 py-2">Enregistrer</button>
            <button type="button" onClick={() => setEditing(null)} className="border border-zinc-700 text-zinc-400 uppercase text-xs px-4">Annuler</button>
          </div>
        </form>
      )}

      <div className="space-y-2">
        {posts.map((p) => (
          <div key={p.id} data-testid="blog-row" className="flex items-center justify-between bg-ink-surface border border-zinc-800 px-4 py-3">
            <div className="min-w-0">
              <p className="text-white font-semibold truncate">{p.title} {!p.published && <span className="text-yellow-400 text-xs">(brouillon)</span>}</p>
              <p className="text-zinc-600 text-xs">/blog/{p.slug} · {new Date(p.created_at).toLocaleDateString("fr-FR")}</p>
            </div>
            <div className="flex gap-2 shrink-0">
              <button onClick={() => setEditing(p)} className="text-zinc-400 hover:text-neon-magenta" data-testid="blog-edit"><Pencil className="h-4 w-4" /></button>
              <button onClick={() => del(p.id)} className="text-zinc-400 hover:text-red-400" data-testid="blog-delete"><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
